import React from "react";
import { Toolbar, ToolbarGroup, Caption2 } from "@fluentui/react-components";
import { ArrowLeftFilled } from "@fluentui/react-icons";
import { useNavigate } from "react-router-dom";
import { useHeaderStyles } from "./style/header.style";

const SubHeader = ({ title, subtitle, icon }) => {
  const styles = useHeaderStyles();
  const navigate = useNavigate();

  const cancelClickHandler = () => {
    navigate("/tabmenu");
  };

  return (
    <Toolbar className={styles.toolbar}>
      <ToolbarGroup>
        <div className={styles.subheader_container}>
          <div style={{ width: "20%" }}>
            <ArrowLeftFilled className={styles.icon24} onClick={cancelClickHandler}></ArrowLeftFilled>
          </div>
          <div className={styles.subheader_item_container}>
            <div className={styles.textcenter}>
              <Caption2>
                {icon}
                {"  "}
                {subtitle}
              </Caption2>
            </div>
            <div className={styles.textcenter}>{title}</div>
          </div>
        </div>
      </ToolbarGroup>
    </Toolbar>
  );
};
export default SubHeader;
